var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_171_11741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6503 9.56642H19.2669L20.8484 3.86523C21.2611 2.3782 20.1463 0.90625 18.6076 0.90625H11.2631C9.85486 0.90625 8.66537 1.95546 8.48496 3.35672L7.02194 14.7229C6.81998 16.2921 8.0382 17.6823 9.61544 17.6823H13.3921L13.2097 26.7206C13.1828 28.046 14.9339 28.5359 15.5948 27.3876L24.2499 12.3455C24.9606 11.1102 24.072 9.56642 22.6503 9.56642Z",
    fill: "#FFDE55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6779 9.62127H19.3451L20.903 3.88397C21.3095 2.38752 20.2114 0.90625 18.6957 0.90625H14.7116C14.2547 1.54574 13.9448 2.4138 14.0082 3.58586C14.1844 6.8327 16.5294 8.18621 15.7794 12.0429C15.5729 13.1048 16.3724 14.0936 17.4292 14.0936C17.4292 14.0936 18.8975 14.0096 18.8975 15.7072L18.4168 22.7812L24.2537 12.4178C24.9537 11.1748 24.0784 9.62127 22.6779 9.62127Z",
    fill: "#FFCD00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_171_11741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.03125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.a6ebf3034ae15e56e4b363a55b4bca22.svg";
export { ForwardRef as ReactComponent };